import React from "react";
export const PlayedGameColumnFormatter = (value) => {
  console.log("PlayedGameColumnFormatter value:", value);

  if (!value || typeof value.totalJoinedUser === 'undefined' || typeof value.numberOfPlayedUsers === 'undefined') {
    return (
      <table width={`100%`} className="table table-borderless">
        <tr width={`100%`}>
          <td width={`50%`}><strong>Total Joined</strong></td>
          <td width={`50%`}><strong>Number Of Played</strong></td>
        </tr>
      </table>
    );
  }

  return (
    <table width={`100%`} className="table table-borderless">
      <tr width={`100%`}>
        <td width={`50%`}>{value.totalJoinedUser}</td>
        <td width={`50%`}>{value.numberOfPlayedUsers}</td>
      </tr>
    </table>
  );
};



export const PlayedGameColumnFormatterr = (row) => {
    const packs = row || [];
    console.log("packssssss", packs);
    return (
      <table width={`100%`} className="table table-borderless">
        {packs.map((pack, index) => (
          <tr key={index} width={`100%`}>
            <td width={`50%`}>
              <div>
                <strong>Pack Name:</strong> {pack.packName || 'N/A'}
              </div>
              <div>
                <strong>Time Duration:</strong> {pack.timeDuration || 'N/A'}
              </div>
              <div>
                <strong>Amount:</strong> {pack.amount || 0}
              </div>
            </td>
          </tr>
        ))}
      </table>
    );
  };
  
  export const PayloadColumnFormatterr = (row) => {
    const payload = row || {}; // Assuming payload is a single object
  console.log(payload,"fdkfdsf")
    return (
      <table width="100%" className="table table-borderless">
        <tbody>
          <tr>
            <td width="50%">
            <div>
                <strong>Date:</strong> {payload.date.startAt || 'N/A'} To {payload.date.endAt || 'N/A'}
              </div>
              <div>
                <strong>Company:</strong> {payload.company || 'N/A'}
              </div>
              <div>
                <strong>Type:</strong> {payload.type || 'N/A'}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  };
  
export const CoinConsumerColumnFormatter = (value) => {
    let totalCoinsCredited = 0, totalCoinsDebited = 0, currentBalance = 0;
    if(value?.totalCoinsCredited && value.totalCoinsCredited >= 0)
    {
        totalCoinsCredited = value?.totalCoinsCredited
    }
    else
    {
        totalCoinsCredited = value?.totalCoinsCredited >= 0 ? 0 : <strong>Credited</strong>
    }
    if(value?.totalCoinsDebited && value.currentBalance >= 0)
    {
        totalCoinsDebited = value?.totalCoinsDebited
    }
    else
    {
        totalCoinsDebited = value?.totalCoinsDebited >= 0 ? 0 : <strong>Debited</strong>
    }
    if(value?.currentBalance && value.currentBalance >= 0)
    {
        currentBalance = value?.currentBalance
    }
    else
    {
        currentBalance = value?.currentBalance >= 0 ? 0 : <strong>Current Balance</strong>
    }

    return <table width={`100%`} class="table table-borderless">
        <tr width={`100%`}>
            <td width={`50%`}>{totalCoinsCredited}</td>
            <td width={`50%`}>{totalCoinsDebited}</td>
            <td width={`50%`}>{currentBalance}</td>
        </tr>
    </table>;
}